import React, { Component } from "react";
import { Button, Icon, Modal } from "semantic-ui-react";

export class ConsignorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      consignorList: []
    };
  }
  handleOpenModal = (consignorList) => {
    console.log("IIIIIIIIIIIIIIIIIIIIIII")
    console.log(this.props)
    console.log(consignorList)
    console.log("EEEEEEEEEEEEEEEEEEEEEEE")

    var arr = []

    consignorList.forEach(element => {
      arr.push(element)
    });

    this.setState({ consignorList: arr }, () => {
    });

    console.log(arr)

    this.setState({ open: true });
  };

  render() {
    return (
      <>
        <div title={this.props.value} onClick={() => this.handleOpenModal(this.props.value)}>{this.props.valueFormatted}</div>

        <Modal
          onClose={() => this.setState({ open: false })}
          //onOpen={() => setOpen(true)}
          open={this.state.open}
        //trigger={<Button>Delivery Reference Number</Button>}
        >
          {/* <Modal.Header>{this.props.column.userProvidedColDef.headerName}</Modal.Header> */}
          <Modal.Content>
            <table className="delivery-reference-number-table">
              <thead>
                <tr>
                  <th><h3 className="padding-l-0">{this.props.column.userProvidedColDef.headerName}</h3></th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.consignorList && this.state.consignorList.map((item, i) => {
                    return (
                      <tr key={i}>
                        <th>{item}</th>
                      </tr>
                    )
                  })
                }
              </tbody>

            </table>

          </Modal.Content>
          <Modal.Actions>
            <Button basic onClick={() => this.setState({ open: false })}>
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}

export default ConsignorModal;
